var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: { placement: "right-start", trigger: "click", width: "400" },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function () {
            return [
              _c("p", [
                _vm._v(
                  "Click to insert the placeholder into the cursor position:"
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-left" },
                _vm._l(_vm.items, function (item) {
                  return _c("item", {
                    key: item.key,
                    attrs: { value: item },
                    on: { select: _vm.onSelect },
                  })
                }),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _vm._t("default", function () {
            return [_vm._v("\n        Placeholders\n    ")]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }